module.exports = __webpack_public_path__ + "img/chevron-up.a7434e26.svg";